import React from 'react';
import cn from 'classnames';
import ViewTitle from '../ViewTitle';

const View = (props) => {
  return (
    <div className={cn('view', props.className)}>
      {props.title && <ViewTitle>{props.title}</ViewTitle>}
      {props.children}
    </div>
  );
};

export default View;
